<template>
  <div class="mit-reservation-activity-list pa-5">
    <v-snackbar top :color="status.color" min-width="0" v-model="status.display" :timeout="status.timeout">
        <b>{{ status.message }}</b>
    </v-snackbar>
    <BaseMitLoading :show="loading" :fullscreen="false"/>
    <BaseMitReserveEdit :managerMode="true" :show="dialogEdit" :existingReservationUniqueId="currentReservationUniqueId" @cancel="cancelReservation" @save="saveReservation" @delete="deleteReservation" @changed-reservation="editorChangedReservationId"/>
    <v-card flat>
      <v-dialog v-model="dialogFilter" persistent max-width="600px">
        <template v-slot:activator="{ on }">
          <v-btn small v-on="on" class="ma-2" @click="resetDialog">Add Filter</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Add Filter</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-select :items="filterableHeaders" :hint="filterItem.hint" :persistent-hint="true" item-text="text" item-value="value" label="Name" required v-model="filterItem" return-object @change="changedFilter"></v-select>
                  <v-text-field label="Value" required v-model="filterValue"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialogFilter = false">Close</v-btn>
            <v-btn color="blue darken-1" text @click="addFilter">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        <BaseMitUrlParams ref="mitUrlParamsRef" v-on:changed="updateFilters"/>
    </v-card>
    <!-- <MitReservationActivityList :reservationActivity="activity" showDetails/> -->
    <BaseMitDataTable
      title="Reservations"
      :page="paging.page"
      :pageSize="paging.pageSize"
      :totalItems="paging.totalItems"
      :pageSizes="{itemsPerPageOptions:[10, 20, 50, 100]}"
      :editable="false"
      :headers="headers"
      :items="reservations"
      :showExpanded="true" 
      itemKey="id"
      :singleExpanded="true"
      @item-expanded="expanded"
      @pagination="updatePagination"
    >
        <template v-slot:expanded-item="{ item }">
            <!-- expand across all the columns, so use the header length -->
            <td class="pa-1" :colspan="headers.length+1">
              <v-card v-if="loadingChildren" elevation="0" height="300">
                              <v-card-text class="text-center">
                                  <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                  <div>Loading...</div>
                              </v-card-text>
                          </v-card>
              <v-simple-table v-else class="row-pointer" fixed-header height="300px">
                <template v-slot:default >
                  <!-- <span v-if="reservations && reservations.length > 0"> -->
                      <thead>
                        <tr>
                            <th class="text-left">ID</th>
                            <th class="text-left">Name</th>
                            <th class="text-left">Space</th>
                            <th class="text-left">Date</th>
                            <th class="text-left">Start</th>
                            <th class="text-left">End</th>
                            <th class="text-left">Setup State</th>
                            <th class="text-left"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- @click="editReservation(r)" -->
                        <tr v-for="r in item.children" :key="r.id">
                          <td>{{ r.uniqueId }}</td>
                          <td><h4>{{r.name || '(none)'}}</h4></td>
                          <td>{{ r.mitId }}</td>
                          <td>{{ r.startDateTime.format('ddd MMM DD YYYY') }}</td>
                          <td>{{ r.startDateTime.format('hh:mm A') }}</td>
                          <td>{{ r.endDateTime.format('hh:mm A') }}</td>
                          <td>
                              <div v-if="item.setupState && item.setupState.length > 0">{{item.setupState}}</div>
                              <div v-else>-</div>
                          </td>
                          <td><v-btn class="" small text outlined color="primary" elevation="0" @click="edit(r)">Modify</v-btn></td>
                        </tr>
                    </tbody>
                </template>
              </v-simple-table>
            </td>
        </template>
        <template v-slot:item.icon="{ item }">
                      <v-icon v-if="item.recurring" color="primary darken-1" class="pr-3">mdi-calendar-refresh-outline</v-icon>
                      <v-icon v-else color="primary darken-1" class="pr-3">mdi-calendar-today-outline</v-icon>
        </template>
        <template #item.data-table-expand="{ index, item, isExpanded, expand }">
          <!-- @click="expand(!isExpanded)"  -->
          <td v-if="item.recurring" class="text-start">
            <!--  @click="tableExpand(expand, isExpanded, item)"-->
            <v-btn icon 
                  @click="tableExpand(expand, isExpanded, item)"
                  class="v-data-table__expand-icon"
                  :class="{'v-data-table__expand-icon--active' : isExpanded}">
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </td>
      </template>
      <template v-slot:item.startDate="{ item }">
        {{ item.startDateTime.format('ddd MMM DD YYYY') }}
      </template>
      <template v-slot:item.startTime="{ item }">
        {{ item.startDateTime.format('hh:mm A') }}
      </template>
      <template v-slot:item.endTime="{ item }">
        {{ item.endDateTime.format('hh:mm A') }}
      </template>
      <template v-slot:item.setupState="{ item }">
                    <div v-if="item.setupState && item.setupState.length > 0">{{item.setupState}}</div>
                    <div v-else>-</div>
                </template>
      <template v-slot:item.modify="{ item }">
        <v-btn class="" small text outlined color="primary" elevation="0" @click="edit(item)">Modify</v-btn>
      </template>
    </BaseMitDataTable>
  </div>
</template>

<script>
import moment from 'moment';
import MitReservationService from '../../base/services/BaseMitReserveService.js';
import MitDateTimeService from '../../base/services/BaseMitReserveDateTimeService.js';
const mitDateTimeService = new MitDateTimeService();

import BaseMitDataTable from '../../base/components/BaseMitDataTable.vue';
import BaseMitUrlParams from '../../base/components/BaseMitUrlParams.vue';
import BaseMitLoading from '../../base/components/BaseMitLoading.vue';
import BaseMitReserveEdit from '../../base/components/reserve/BaseMitReserveEdit.vue';

export default {
  name: 'MitManageReservations',
  components: {
    BaseMitLoading,
    BaseMitDataTable,
    BaseMitUrlParams,
    BaseMitReserveEdit
  },
  props: {
  },
  data: function() {
    return {
      status:{
            display:false,
            timeout:3000,
            message:'Saved!',
            color:'primary'
      },
      dialogFilter:false,
      dialogEdit:false,
      filterItem:null,
      filterValue:'',
      loading:false,
      loadingChildren:false,
      search: '',
      options:{},
      paging:{
        page:1,
        pageSize:5,
        totalItems:0
      },
      filterableHeaders:[ 
        {text: 'Name',value: 'name', default:'', hint:'The name of the reservation, will match like'},
        {text: 'Owner',value: 'owner', default:'', hint:'The exact csail id'},
        {text: 'Id',value: 'id', default:'', hint:'The exact id of the activity'},
        {text: 'Unique Id',value: 'uniqueId', default:'', hint:'The exact unique id of the reservation'},
        {text: 'Start Date',value: 'start', default:mitDateTimeService.getDateStringNowLocal(), hint:'Create Date >=. Format is "YYYY-MM-DD HH:mm:ss" 24h local time.'},
        {text: 'End Date',value: 'end', default:mitDateTimeService.getDateStringNowLocal(), hint:'End Date <=. Format is "YYYY-MM-DD HH:mm:ss" 24h local time.'},
        {text: 'Space',value: 'mitId', default:'', hint:'The exact space id'}
      ],
      headers:[
          { text: '', value: 'data-table-expand', width:10 },
          {text: '',sortable: true,value: 'icon', width:10},
          {text: 'Name',sortable: true,value: 'name'},
          {text: 'ID',sortable: true,value: 'uniqueId'},
          {text: 'Space',sortable: false,value: 'mitId'},
          {text: 'Date',sortable: true,value: 'startDate'},
          {text: 'Start',sortable: true,value: 'startTime'},
          {text: 'End',sortable: true,value: 'endTime'},
          {text: 'Owner',sortable: false,value: 'owner'},
          {text: 'Setup',sortable: false,value: 'setupState'},
          {text: '',sortable: false,value: 'modify'},
        ],
      reservations:[],
      currentReservationUniqueId:null,
      // tableCurrentExpanded:null,
      tableCurrentExpandFunction:null,//used to close the table row if its expanded, when updating
      mitDateTimeService: new MitDateTimeService()
    }
  },
  created() {
    this.resetDialog();
  },
  mounted() {
      if(this.$route.params.id){
            this.currentReservationUniqueId = this.$route.params.id;
            this.dialogEdit = true;
        }
  },
  methods : {
    tableExpand(expandFunction, isExpanded){
      this.tableCurrentExpandFunction = expandFunction;
      expandFunction(!isExpanded);
    },
    editorChangedReservationId(uniqueId){
        this.updateUrl(uniqueId)
    },
    updateUrl(uniqueId){
            let url;

            if(uniqueId !== null && uniqueId.length > 0){
                url = {
                    path: '/reservations/manage/'+ uniqueId,
                    query: {}
                }
            }
            else{
                url = {
                    path: '/reservations/manage',
                    query: {}
                }
            }
            
            //test to make sure we don't try to change to the same url.
            //the router doesn't like this
            if(this.$router.currentRoute.path != url.path){
              this.$router.push(url);
            }
    },
    edit(reservation){
            this.updateUrl(reservation.uniqueId);
            this.dialogEdit = true;
            this.currentReservationUniqueId = reservation.uniqueId;
    },
    cancelReservation(){
          this.updateUrl(null);
          this.dialogEdit = false;
    },
    saveReservation(reservation){
            this.loadingSave = true;

            MitReservationService.saveManager(reservation)
              .then((data) => {
                  this.loadingSave = false;
                  this.status.message = 'Saved!',
                  this.status.color = 'primary'
                  this.status.display = true;
                  this.dialogEdit = false;
                  this.updateUrl(null);
                  this.refreshData(this.paging, this.options);
              })
              .catch((error) => {
                  this.loadingSave = false;
                  this.dialogEdit = false;
                  this.updateUrl(null);
                  this.status.message = 'An error occurred trying to get the reservable spaces.';
                  this.status.display = true;
                  this.status.color = 'red';
                  this.errorsSpaces = ['Error getting available spaces from space app.']
                  console.log('ERROR:', error);
              });
    },
    deleteReservation(reservation){
            this.loadingDelete = true;
            this.dialogEdit = false;
            this.updateUrl(null);
            MitReservationService.deleteManager(reservation.uniqueId)
              .then((data) => {
                  this.loadingDelete = false;

                  if(data.numDeleted <= 0){
                      this.status.message = 'Could not delete reservation or reservation was already deleted.';
                      this.status.color = 'red';
                      this.status.display = true;
                  }
                  else{
                      this.status.message = 'Deleted Reservation.',
                      this.status.color = 'primary'
                      this.status.display = true;
                  }
                  this.refreshData(this.paging, this.options);
              })
              .catch((error) => {
                  this.loadingDelete = false;
                  this.status.message = 'An error occurred trying to get delete the reservation.';
                  this.status.display = true;
                  this.status.color = 'red';
                  this.errorsSpaces = ['Error getting available spaces from space app.']
                  console.log('ERROR:', error);
              });

    },
    updatePagination (pagination) {
      //setting this into the control will trigger this event so initiall don't bother refreshing
      //if the items length is zero, we have no data yet.
      if(pagination.itemsLength > 0){
        this.paging.page = pagination.page;
        this.paging.pageSize = pagination.itemsPerPage;

        this.refreshData(this.paging, this.options);
      }

    },
    updateFilters(options){
      this.options = options;
      this.paging.page = 1;//we changed the filter so start over with a new data set
      this.refreshData(this.paging, this.options);
    },
    refreshData(pagination, options){
      this.loading = true;

      MitReservationService.getManagerGroupedReservations(pagination, options)
        .then((data) => {
          this.loading = false;
          this.reservations = [];

          this.reservations = data.reservations;
          this.paging.totalItems = data.total;

          if(this.tableCurrentExpandFunction){
            this.tableCurrentExpandFunction(false);
          }
          
        })
        .catch((error) => {
          this.loading = false;
          console.log('An error occurred trying to get reservations list', error);
        });
    },
    // refreshChildrenData(tableExpandedReservation){
    //     // tableCurrentExpanded.value = false;

    //     if(tableExpandedReservation && tableExpandedReservation.recurring){
    //       this.loadingChildren = true;

    //       MitReservationService.getManagerRecurringChildren(tableExpandedReservation.uniqueId)
    //           .then((data) => {
    //             this.loadingChildren = false;
                

    //             //empty the existing children array reference and populate them.
    //             if(tableExpandedReservation.children){
    //               tableExpandedReservation.children.splice(0,tableExpandedReservation.children.length);
    //             }
    //             else{
    //               //otherwise create the array
    //               tableExpandedReservation.children = [];
    //             }

    //             for(let x = 0; x < data.reservations.length; x++){
    //                   tableExpandedReservation.children.push(data.reservations[x]);
    //             }
    //           })
    //           .catch((error) => {
    //             this.loadingChildren = false;
    //             console.log('An error occurred trying to get reservations list', error);
    //           });
    //     }
    // },
    resetDialog(){
      this.filterItem = this.filterableHeaders[5];
      this.filterValue = null;
    },
    changedFilter(item){
      this.filterValue = item.default;
    },
    addFilter(){
      if(mitDateTimeService.isDateTimeFormatValid(this.filterValue)){
        this.filterValue = mitDateTimeService.convertLocalTimeToUTCServerFormat(moment(this.filterValue, "YYYY-MM-DD HH:mm:ss", true));
      }

      this.$refs.mitUrlParamsRef.add(this.filterItem.value, this.filterValue);
      this.dialogFilter = false;
    },
    expanded(event){
      this.loadingChildren = true;
      MitReservationService.getManagerRecurringChildren(event.item.uniqueId)
          .then((data) => {
            this.loadingChildren = false;
            event.item.children = data.reservations;
          })
          .catch((error) => {
            this.loadingChildren = false;
            console.log('An error occurred trying to get reservations list', error);
          });
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
